import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import { FAQ } from '../FAQ/faqs';
import Footer from '../Footer';



function CRMAndCustomerPortal() {
  return (
    <>
<Features docname="CRM and Customer Portal"/>
<Advantages docname="CRM and Customer Portal"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>
    </>
  );
}

export default CRMAndCustomerPortal;
